// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cBux","colMin":"styles_colMin__32Fni"};